<template>
  <base-page-layout class="view-segmentation" title="Visualizar Segmentação">
    <mf-loading-dialog :loading="loading">
      <v-container v-if="hasValidSegment" fluid>
        <v-row no-gutters>
          <v-col>
            <v-alert class="alert-color" dense elevation="1" icon="mdi-alert-outline">
              <span class="font-weight-bold mr-1 text-cinza-d10">Atenção:</span><span class="text-cinza-d10">{{ warning }}</span>
            </v-alert>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <title-description
              class="mb-4"
              :title.sync="segment.name"
              :description.sync="segment.description"
              disable-title
              disable-description
              no-max-height
              mode="segmentation"
            />
          </v-col>
          <v-col cols="auto">
            <segmentation-fixed-size :size="segment.size" :segment="segment" />
          </v-col>
        </v-row>

        <v-row>
          <v-col v-if="selectedCriteria && !$wait.is('get-segmentation-structure')" cols="3" class="criterio-details-content edit-criteria">
            <criterio-details disabled viewOnly />
          </v-col>
          <v-col v-if="!selectedCriteria && !$wait.is('get-segmentation-structure')" cols="3" class="criterio-details-content edit-criteria">
            <v-card class="no-criterio-selected-card">
              <span class="no-criterio-selected-title">Selecione um critério ao lado para visualizar</span>
            </v-card>
          </v-col>

          <v-col id="criteria-group" cols="9" class="criterio-details-content group-criteria space-between">
            <segmentation-group viewOnly />
          </v-col>
        </v-row>
      </v-container>

      <v-container v-else>
        <v-row no-gutters>
          <v-col>
            <v-alert type="error" dense elevation="1">
              <span class="mr-1"
                >Informações de visualização do segmento não disponíveis para esta oferta. Clique
                <span class="link-text" @click="closeViewSegmentation">aqui</span>
                para fechar.</span
              >
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </mf-loading-dialog>
  </base-page-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import BasePageLayout from '@/components/BasePageLayout.vue'
import SegmentationGroup from '@/modules/clientes/segmentation/views/components/SegmentationGroup.vue'
import CriterioDetails from '@/modules/clientes/segmentation/views/components/CriterioDetails.vue'
import SegmentationFixedSize from '@/modules/clientes/segmentation/views/components/SegmentationFixedSize.vue'
import TitleDescription from '@/modules/campanhas/views/components/edit/TitleDescription.vue'
import { DateTime } from 'luxon'
import { QUERY_OFFER_SCHEDULE_SEGMENT } from '../../graphql'

export default {
  components: {
    BasePageLayout,
    SegmentationGroup,
    CriterioDetails,
    SegmentationFixedSize,
    TitleDescription,
  },

  data: () => {
    return {
      segment: {
        _id: '',
        name: '',
        description: '',
        date: '',
        size: 0,
      },

      loading: true,
    }
  },

  computed: {
    ...mapState({
      criterions: (state) => state.segmentation.segmentation,
      selectedCriteria: (state) => state.segmentation.selectedCriteria,
    }),

    warning() {
      const date = DateTime.fromISO(this.segment.date).toLocaleString(DateTime.DATE_FULL)
      return `A visualização dos critérios do segmento é estática. A referência dos critérios foi atualizada pela última vez em ${date}.`
    },

    hasValidSegment() {
      return Boolean(this.segment._id)
    },
  },

  created() {
    this.getData()
  },

  methods: {
    ...mapActions(['setSegmentationGroups']),

    ...mapWaitingActions({
      getSegmentationStructure: 'get-segmentation-structure',
    }),

    async getSegmentation() {
      const response = await this.$apollo.query({
        query: QUERY_OFFER_SCHEDULE_SEGMENT,
        variables: {
          _id: this.$route.params.campaignId,
          segment_id: this.$route.params.segmentId,
        },
        context: {
          uri: this.$microservicesUrls['sales'],
        },
        fetchPolicy: 'no-cache',
      })

      if (!response || !response.data || !response.data.offerScheduleSegment) return

      let segment = response.data.offerScheduleSegment

      const segmentationGroups = JSON.parse(segment.data)
      this.setSegmentationGroups(segmentationGroups)
      this.segment._id = this.$route.params.segmentId
      this.segment.name = segment.name
      this.segment.description = segment.description
      this.segment.date = segment.clients_refreshed_at
      this.segment.size = segment.segment_clients_quantity
    },

    async getData() {
      this.loading = true
      const modules = Object.entries(this.$getAllowedModules())
        .filter(([_, value]) => value)
        .map(([key]) => key)

      await Promise.all([this.getSegmentationStructure(modules), this.getSegmentation()])
      this.loading = false
    },

    cancel() {
      this.$router.push('/clientes/segmentacao').catch(() => {})
    },

    closeViewSegmentation() {
      window.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.view-segmentation {
  overflow-x: hidden;

  .alert-color {
    background-color: #fff9e3;
  }

  .text-cinza-d10 {
    color: $cinza-d10;
  }

  .criterio-details-content {
    @media screen and (min-width: 1367px) {
      height: calc(100vh - 300px);
    }

    @media screen and (max-width: 1366px) {
      height: calc(100vh - 300px);
    }
    overflow-y: auto;
    overflow-x: hidden;
  }

  .edit-criteria {
    width: 450px;
  }

  .group-criteria {
    width: calc(100% - 450px);
  }

  .no-criterio-selected-card {
    border-radius: 10px !important;
    padding: 20px;
    min-height: 196px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .no-criterio-selected-title {
      font-size: 18px;
    }
  }

  .space-between {
    display: flex;
    flex-direction: column;
  }

  .link-text {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
